// Canonical Disposition Status list, ordered by the sales funnel / lead lifecycle.
// Order is intentional — do NOT alphabetize. Existing statuses are preserved so
// historical leads keep displaying correctly; new funnel stages are added in place.
export const DISPOSITION_STATUSES = [
  'Prospective',
  'Self-Registered',        // institution registered themselves during portal sign-up
  'Customer Reached Out',
  'Demo Scheduled',
  'Demo Completed',
  'Quotation Sent',
  'Negotiation',
  'Won',
  'Converted',              // won and converted to a hospital account (has backend logic)
  'Implemented',
  'Lost',
  'Cold',
  'Dropped'
];

// Default multi-select for the leads list filter: show everything except 'Dropped'.
export const DEFAULT_DISPOSITION_SELECTION = DISPOSITION_STATUSES.filter(
  (status) => status !== 'Dropped'
);
